<app-uni-page [parent]="this" pageTitle="Utilities - Stranded Job Orders" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"/>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full" *ngIf="isPageReady">

    <div class="qb-list-actions flex items-center gap-3">
      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-refresh"
              [loading]="isLoading" [disabled]="isLoading" (click)="runSearch()">
        <span>{{ isLoading ? 'Please wait...' : 'Populate' }}</span>
      </button>

      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-list"
              [disabled]="isLoading || !hasRun || selectedJoHeaderId == null" (click)="showAllItems()">
        <span>Show Items For All Orders</span>
      </button>

      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-check-circle"
              [loading]="isClosing" [disabled]="isLoading || isClosing || closableOrders.length === 0"
              (click)="closeCompleteOrders()">
        <span>Close Complete Orders ({{ closableOrders.length }})</span>
      </button>

      <span *ngIf="isLoading" class="text-sm flex items-center gap-2">
        <i class="pi pi-spin pi-spinner"></i>
        The system examines every open job order.
      </span>

      <span *ngIf="result && !isLoading" class="text-sm">
        Last run: {{ result.RunTs | date: 'short' }}
      </span>
    </div>

    <div *ngIf="result && !isLoading" class="px-4 pb-3 shrink-0">
      <div class="qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">
          Result
        </div>

        <table class="qb-info-table w-full">
          <tr class="font-semibold">
            <td class="value text-right">Job orders</td>
            <td class="value text-right">Items on a voucher</td>
            <td class="value text-right">Ship bin still open</td>
            <td class="value text-right">Invoice waits to post</td>
            <td class="value text-right">Invoice has no QuickBooks id</td>
          </tr>
          <tr>
            <td class="value text-right">{{ result.JobOrderCount }}</td>
            <td class="value text-right">{{ result.StrandedItemCount }}</td>
            <td class="value text-right">{{ result.OpenShipBinCount }}</td>
            <td class="value text-right">{{ result.AwaitPostCount }}</td>
            <td class="value text-right">{{ result.NoQbIdCount }}</td>
          </tr>
        </table>

        <div *ngFor="let note of result.Notes" class="text-sm mt-2">{{ note }}</div>
      </div>
    </div>

    <p-splitter class="w-full grow min-h-0" layout="vertical" styleClass="h-full" [panelSizes]="[55, 45]">
      <ng-template pTemplate>
        <div class="flex h-full w-full flex-col overflow-hidden">
          <div class="qb-child-actions shrink-0">
            <span class="text-sm font-semibold">Job orders that did not close</span>
          </div>
          <app-ag-grid [gridOptions]="johGridOptions" [rowData]="jobOrders" class="min-h-0 flex-1"></app-ag-grid>
        </div>
      </ng-template>

      <ng-template pTemplate>
        <div class="flex h-full w-full flex-col overflow-hidden">
          <div class="qb-child-actions shrink-0">
            <span class="text-sm font-semibold">{{ itemCountLabel }}</span>
          </div>
          <app-ag-grid [gridOptions]="itemGridOptions" [rowData]="items" class="min-h-0 flex-1"></app-ag-grid>
        </div>
      </ng-template>
    </p-splitter>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
